var map = {
	"./a.wav": 5812,
	"./aHat.wav": 7030,
	"./aSmile.wav": 3744,
	"./b.wav": 6672,
	"./c.wav": 413,
	"./d.wav": 3615,
	"./dLine.wav": 6802,
	"./e.wav": 4166,
	"./eHat.wav": 957,
	"./g.wav": 1563,
	"./h.wav": 4269,
	"./i.wav": 662,
	"./k.wav": 2727,
	"./l.wav": 3701,
	"./m.wav": 1258,
	"./n.wav": 1680,
	"./o.wav": 2472,
	"./oHat.wav": 7090,
	"./oHook.wav": 7065,
	"./p.wav": 5901,
	"./q.wav": 9925,
	"./r.wav": 8154,
	"./s.wav": 157,
	"./t.wav": 311,
	"./u.wav": 9827,
	"./uHook.wav": 702,
	"./v.wav": 6286,
	"./x.wav": 865,
	"./y.wav": 3720
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9982;